import type { ButtonHTMLAttributes } from 'react'

import CircularProgress from '@mui/material/CircularProgress'

/**
 * @deprecated use `src/shared/ui/Button/LoadingButton.tsx` instead
 */
export const ResponsiveButton = ({
	children,
	className,
	isLoading = false,
	onClick,

	...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
	isLoading?: boolean
}) => (
	<button
		className={className}
		onClick={isLoading ? undefined : onClick}
		{...props}
	>
		{isLoading ? (
			<CircularProgress
				classes={{ colorPrimary: 'material-loader-black' }}
				size={20}
			/>
		) : (
			children
		)}
	</button>
)
